module.exports = __webpack_public_path__ + "static/img/blackmores.2106631.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand/blackmores.jpg
// module id = 246
// module chunks = 1